import type { Ref } from "vue";
import type { PublishedThemeConfig, UniqueThemeDto } from "../types";
import { useState } from "#imports";

/**
 * A state for storing the current theme
 */
export const useThemeState = (): Ref<string | null> => useState<string | null>( "theme", () => null );

/**
 * A state for storing the list of known themes
 */
export const useThemeListState = (): Ref<UniqueThemeDto[]> => useState<UniqueThemeDto[]>( "themes", () => [] );

/**
 * A state for storing the config for any previously used themes
 */
export const useThemeConfigListState = (): Ref<Record<string, PublishedThemeConfig>> => useState<Record<string, PublishedThemeConfig>>( "themes-config", () => ( {} ) );
